import React from "react";
import axios from "axios";
import FormErrorHandler from "../../components/FormErrorHandler";

export default class masterdataMeasurementsFormPremise extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: {},
            premise: "",
            score: 0,
            order: 0
        };

        this.updateElementState = this.updateElementState.bind(this);
        this.checkElementValue = this.checkElementValue.bind(this);
        this.updatePremise = this.updatePremise.bind(this);
    }

    updateElementState(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    checkElementValue(e) {
        if (this.state.premise.match(/(Antwoord (\d+))/g)) {
            this.setState({
                premise: ""
            });
        }
    }

    updatePremise(e) {
        let postData = {
            premise: this.state.premise,
            score: this.state.score,
            order: this.state.order
        };

        if (postData.premise) {
            axios.patch("/v1/measurementpremises/" + this.props.uuid + "/", postData).catch((error) => {
                this.setState({
                    errorMessage: error.response.data
                });
                scrollToElem(document.querySelector(".form-error"));
            });
        }
    }

    componentDidMount() {
        axios
            .get("/v1/measurementpremises/" + this.props.uuid + "/")
            .then((response) => {
                this.setState({
                    premise: response.data.premise,
                    score: response.data.score,
                    order: response.data.order
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (
            <div className="row">
                <div className="col-7">
                    <div className="form-group">
                        <label>Antwoord</label>
                        <input
                            type="text"
                            name="premise"
                            className="form-control form-control-md"
                            required={true}
                            onFocus={this.checkElementValue}
                            onChange={this.updateElementState}
                            onBlur={this.updatePremise}
                            value={this.state.premise}
                        />
                        <FormErrorHandler fieldName="premise" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group">
                        <label>Positie</label>
                        <input
                            type="number"
                            name="order"
                            className="form-control form-control-md"
                            required={true}
                            onChange={this.updateElementState}
                            onBlur={this.updatePremise}
                            value={this.state.order}
                        />
                        <FormErrorHandler fieldName="order" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group">
                        <label>Aantal punten</label>
                        <input
                            type="number"
                            name="score"
                            className="form-control form-control-md"
                            required={true}
                            onChange={this.updateElementState}
                            onBlur={this.updatePremise}
                            value={this.state.score}
                        />
                        <FormErrorHandler fieldName="score" errorObject={this.state.errorMessage} />
                    </div>
                </div>
                <div className="col-1">
                    <div className="form-group">
                        <label>&nbsp;</label>
                        <br />
                        <div className="btn btn-sm btn-light" onClick={() => this.props.deletePremise(this.props.uuid)}>
                            <i className="fa fa-times"></i>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
